(function () {
    'use strict';
    angular.module('doclr.availabilityReleaseStrategy', []);
})();
